import { get, map } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationEdit = get('reservation.routes.edit');

export const getEditReservationData = createSelector(
  getReservationEdit,
  get('data')
);

export const getEditReservationPrograms = createSelector(
  getEditReservationData,
  get('programs')
);

export const getEditReservationProgramIds = createSelector(
  getEditReservationPrograms,
  map('id')
);

export const getIsFetching = createSelector(
  getReservationEdit,
  get('fetching')
);

export const getIsFetched = createSelector(getReservationEdit, get('fetched'));

export const getIsSaving = createSelector(getReservationEdit, get('saving'));

export const getIsSaved = createSelector(getReservationEdit, get('saved'));
